import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Astound,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  ATT,
  BrightspeedV2,
  QuantumFiber,
  CenturyLink,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Earthlink,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

export const Centerfield: SingleProviderConfig = {
  name: 'Centerfield',
  micrositeCode: 'centerfield',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '888-970-0125',
  fallbackLeadModePhoneNumber: '888-970-0104',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    BrightspeedV2,
    QuantumFiber,
    CenturyLink,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
    Earthlink,
  ],
  // TODO: async broken by legacy GBF removal
  // will be restored when migrated to config tool, once call center is ready
  getCheckoutType: asyncEligible,
};
